import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';

const RoomForm = ({ departments }) => {
  const { t } = useTranslation();

  return (
    <>
      <CollapseBlock>
        <Col span={3}>
          <FormTextField
            label={<span style={{ whiteSpace: 'nowrap' }}>{t('Označenie miestnosti')}</span>}
            name={'title'}
            rules={[required(t)]}
          />
        </Col>
        <FormSwitch label={t('Katedrová')} name={'department_room'} />
        <Col span={6}>
          <FormSelect
            label={t('Pracovisko')}
            name={'department_id'}
            options={departments}
            rules={[required(t)]}
          />
        </Col>
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'rooms'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </CollapseBlock>
    </>
  );
};

RoomForm.propTypes = {
  props: PropTypes.any,
  departments: PropTypes.array,
};

export default RoomForm;
